import { render, staticRenderFns } from "./PushSetting.vue?vue&type=template&id=c5748b16&"
import script from "./PushSetting.vue?vue&type=script&lang=js&"
export * from "./PushSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports